import type { ResourceItem, ResourceVisibility } from './types';
import { readResourceOverlay } from './resourceCatalogStore';

/**
 * Seed catalog until central/content CMS is wired.
 * Explainer HTML: public/resources/assets/krysalis_explainer.html
 * Admin overlay (localStorage) merges on top by slug until persist API lands.
 */
export const RESOURCE_CATALOG: ResourceItem[] = [
  {
    id: 'res-krysalis-explainer',
    slug: 'krysalis-explainer',
    title: 'Krysalis explainer — control surfaces & methodology',
    summary:
      'A short walkthrough: VGR, entropy, Mission Control, and Drive — why running a complex business does not have to feel complex.',
    kind: 'explainer',
    visibility: 'public',
    publishedAt: '2026-07-22',
    tags: ['methodology', 'control-bridge', 'education', 'vgr'],
    htmlPath: '/resources/assets/krysalis_explainer.html',
  },
  {
    id: 'res-attention-doctrine-intro',
    slug: 'attention-doctrine-intro',
    title: 'Attention doctrine — why magnets open conversations',
    summary: 'Short member-facing note on how lead magnets set the opening frame, not the whole conversation.',
    kind: 'article',
    visibility: 'authenticated',
    publishedAt: '2026-07-22',
    tags: ['demand', 'attention'],
    bodyMarkdown:
      'Lead magnets and landing pages pass a **source key** into the prospect agent.\n\nThe key sets the entry; the agent still uncovers real demand.',
  },
];

/** Seed + admin overlay (overlay wins on slug collision). */
export function getMergedResourceCatalog(): ResourceItem[] {
  const overlay = readResourceOverlay();
  const bySlug = new Map<string, ResourceItem>();
  for (const item of RESOURCE_CATALOG) bySlug.set(item.slug, item);
  for (const item of overlay) bySlug.set(item.slug, item);
  return Array.from(bySlug.values());
}

export function listResources(options?: {
  includeAuthenticated?: boolean;
  visibility?: ResourceVisibility;
}): ResourceItem[] {
  const includeAuth = options?.includeAuthenticated === true;
  return getMergedResourceCatalog()
    .filter((item) => {
      if (options?.visibility) return item.visibility === options.visibility;
      if (item.visibility === 'public') return true;
      return includeAuth;
    })
    .sort((a, b) => b.publishedAt.localeCompare(a.publishedAt));
}

export function getResourceBySlug(slug: string): ResourceItem | undefined {
  return getMergedResourceCatalog().find((item) => item.slug === slug);
}

export function canAccessResource(
  item: ResourceItem,
  isAuthenticated: boolean
): boolean {
  if (item.visibility === 'public') return true;
  return isAuthenticated;
}
